<template>
  <div class="home">
    <div class="head-title">权限管理</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="onSubmit = true"
            >添加</el-button>
          <el-button
              type="primary"
              @click="showShopList = true"
          >查看套餐</el-button>
          <el-table
            :data="tableData"
            
            border
            style="margin-top: 2.0rem"
          >
            <el-table-column
              prop="priveName"
              label="权限名称"
              style="width: 45%"
            ></el-table-column>
            <el-table-column
              prop="basics"
              label="基础售价"
              style="width: 45%"
            ></el-table-column>
            <el-table-column
              prop="crm_person"
              label="CRM使用人数"
              style="width: 45%"
            ></el-table-column>
            <el-table-column
              prop="session_person"
              label="会话存档使用人数"
              style="width: 45%"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" style="width: 10%">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  @click="dele(scope.row.id)"
                  size="mini"
                >
                 删除
                </el-button>
                <el-button
                  type="primary"
                  @click="
                    (dialogVisible = true),
                      modify(
                        scope.row.id,
                        scope.row.priveName,
                        scope.row.basics,
                        scope.row.crm_person,
                        scope.row.session_person,
                        scope.row
                      )
                  "
                  size="mini"
                >
                  编辑
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-dialog title="修改权限"  center :visible.sync="dialogVisible" width="30%">
          <el-form ref="form" :model="form" label-width="13.0rem">
            <el-form-item label="修改权限">
              <el-input clearable v-model="dengj">{{ dengj }}</el-input>
            </el-form-item>
            <el-form-item label="修改售价">
              <el-input clearable type="number" v-model="shoujia">{{ shoujia }}</el-input>
            </el-form-item>
            <el-form-item label="CRM使用人数">
              <el-input clearable type="number" v-model="people">{{ people }}</el-input>
            </el-form-item>
            <el-form-item label="会话存档使用人数">
              <el-input clearable type="number" v-model="crmpeople">{{ crmpeople }}</el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="(dialogVisible = false), vak()"
              >确 定</el-button
            >
          </span>
        </el-dialog>
        <el-dialog title="添加用户权限" center :visible.sync="onSubmit" width="30%">
          <el-form ref="form" :model="form" label-width="13.0rem">
            <el-form-item label="权限名称">
              <el-input clearable v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="基础售价">
              <el-input clearable type="number" v-model="form.money"></el-input>
            </el-form-item>
            <el-form-item label="CRM使用人数">
              <el-input clearable type="number"  v-model="form.crm_person"></el-input>
            </el-form-item>
            <el-form-item label="会话存档使用人数">
              <el-input clearable type="number"  v-model="form.session_person"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="onSubmit = false">取 消</el-button>
            <el-button type="primary" @click="numoo()">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="商城套餐" center :visible.sync="showShopList">
          <el-table :data="shopListData">
            <el-table-column property="group_name" label="套餐名称"></el-table-column>
            <el-table-column property="fee" label="价格">
              <template slot-scope="scope">{{scope.row.fee}}元/年</template>
            </el-table-column>
          </el-table>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      shopListData:[],//商城套餐数据
      showShopList:false,//商城套餐的显示
      tableData: [],
      formInline: {
        user: "",
      },
      dialogVisible: false,
      form: {
        name: "",
        money: "",
        crm_person: "",
        session_person: "",
      },
      onSubmit: false,
      modifys: "", //修改点击来接收的id,
      dengj: "", //获取修改名称的
      shoujia: "", //获取修改售价的
      people: "",
      crmpeople: "",
      crm_person: "",
      session_person: "",
      tooken: "",
      title: {},
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.abo();
    this.getShopList()
  },
  methods: {
    //获取商城套餐列表
    getShopList() {
      this.axios
          .post(
              "/api/Prive/getGroupList",
              qs.stringify({
                // agenttoken: this.username.agenttoken,
              }),
              {
                headers: {"Content-Type": "application/x-www-form-urlencoded"},
              }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/mine");
            }
            this.shopListData = res.data.data
          })
          .catch(function (err) {
          });
    },
    abo() {
      this.axios
        .post(
          "/api/Prive/getPriveList",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    //  通过点击事件触发监听事件
    modify(e, l, o, p, k, n) {
      this.modifys = e;
      this.dengj = l;
      this.shoujia = o;
      this.crm_person = p;
      this.session_person = k;
      this.people = n.crm_person;
      this.crmpeople = n.session_person;
    },
    //修改代理商等级
    vak() {
      // 修改代理商等级
      var bbb = this.shoujia;
      var aaa = this.dengj;
      if (aaa !== "" && bbb !== "") {
        this.axios
          .post(
            "/api/Prive/editPrive",
            qs.stringify({
              priveName: this.dengj,
              basics: this.shoujia,
              id: this.modifys,
              totaltoken: this.tooken.totaltoken,
              session_person: this.crmpeople,
              crm_person: this.people,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/Tagent");
            }
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.abo();
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
          })
          .catch(function (err) {});
      } else {
        this.$message.error("修改权限不能为空");
        return;
      }
    },

    handleClick(row) {},
    // 删除代理等级管理
    dele(e) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/api/Prive/delPrive",
              qs.stringify({
                totaltoken: this.tooken.totaltoken,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/Tagent");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.abo();
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message.error("取消删除");
        });
    },
    numoo() {
      if (this.form.name !== "") {
        this.axios
          .post(
            "/api/Prive/addPrive",
            qs.stringify({
              priveName: this.form.name,
              basics: this.form.money,
              totaltoken: this.tooken.totaltoken,
              session_person: this.form.session_person,
              crm_person: this.form.crm_person,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/Tagent");
            }
            if (res.data.code == 1) {
              this.onSubmit = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.onSubmit = true;
              this.$message.error(res.data.msg);
            }
            this.abo();
          })
          .catch(function (err) {});
      } else {
        this.$message.error("添加权限不能为空");
        return;
      }
    },
  },
};
</script>
<style scoped>
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0,0,0,0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 26px;
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
</style>

